import { store } from "../../../../../redux/store";
import { safeRedirect, ssoToOldOnlineURL } from "../../../../utils/location";
import { gaEvent } from "../../../../utils/analytics";
import { selectors as userSelectors } from "../../../../../redux/user";

export const currentUser = () => userSelectors.getUser(store.getState());

export const navigateTo = (event, dest, analyticName) => {
  event.preventDefault();
  ssoToOldOnlineURL(dest, true, currentUser());
  gaEvent(`header/${analyticName}`);
};

export const navigateSafelyTo = (
  event,
  dest,
  analyticName,
  target = "_blank"
) => {
  event.preventDefault();
  gaEvent(`header/${analyticName}`);
  safeRedirect(dest, target);
};
